import PositionPref from "../../enums/position-pref";
import FootballState from "../../state/football-state";
import Pref from "./position-pref";

export default class TackledByPositionPref extends Pref {
    constructor(play, fragment) {
        super(play, fragment);
    }

    resolve() {
        if (this.play.historyContains(FootballState.Pass)) {
            return PositionPref.PASS_TACKLE;
        }
        if (this.play.historyContains(FootballState.Rush)) {
            return PositionPref.RUSH_TACKLE;
        }
        return [];
    }
}
